import axios from 'axios';

// URL de base pour l'API backend
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const signCerfa = async (folderId) => {
  try {
    if (!folderId) {
      throw new Error('ID de dossier invalide');
    }
    
    const response = await axios.post(
      `${API_BASE_URL}/api/contracts/sign-cerfa`,
      { folderId },
      { 
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}` 
        },
        timeout: 30000
      }
    );
    
    if (!response || response.status !== 200) {
      throw new Error(`Échec de l'envoi du document: ${response?.statusText || 'Erreur de connexion'}`);
    }
    
    return response.data;
  } catch (error) {
    if (error.code === 'ECONNREFUSED') {
      throw new Error('Impossible de se connecter au serveur. Vérifiez que le serveur backend est en cours d\'exécution.');
    }
    throw error.response?.data?.error || error.message || 'Erreur inconnue';
  }
};

export const signConvention = async (folderId) => {
  try {
    if (!folderId) {
      throw new Error('ID de dossier invalide');
    }
    
    const response = await axios.post(
      `${API_BASE_URL}/api/contracts/sign-convention`,
      { folderId },
      { 
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}` 
        },
        timeout: 30000
      }
    );
    
    // Vérifier la réponse
    if (!response || response.status !== 200) {
      throw new Error(`Échec de l'envoi du document: ${response?.statusText || 'Erreur de connexion'}`);
    }
    
    return response.data;
  } catch (error) {
    if (error.code === 'ECONNREFUSED') {
      throw new Error('Impossible de se connecter au serveur. Vérifiez que le serveur backend est en cours d\'exécution.');
    }
    throw error.response?.data?.error || error.message || 'Erreur inconnue';
  }
};

export const signRupture = async (contractId) => {
  try {
    if (!contractId) {
      throw new Error('ID de contrat invalide');
    }
    
    const response = await axios.post(
      `${API_BASE_URL}/api/contracts/sign-rupture`,
      { contractId },
      { 
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}` 
        },
        timeout: 30000
      }
    );
    
    // Vérifier la réponse
    if (!response || response.status !== 200) {
      throw new Error(`Échec de l'envoi du document: ${response?.statusText || 'Erreur de connexion'}`);
    }
    
    return response.data;
  } catch (error) {
    if (error.code === 'ECONNREFUSED') {
      throw new Error('Impossible de se connecter au serveur. Vérifiez que le serveur backend est en cours d\'exécution.');
    }
    throw error.response?.data?.error || error.message || 'Erreur inconnue';
  }
};


export const checkSignatureStatus = async (procedureId) => {
  try {
    if (!procedureId) {
      throw new Error('ID de procédure manquant');
    }

    // Appeler l'API backend pour vérifier le statut de la signature de la convention
    const response = await axios({
      method: 'get',
      url: `${API_BASE_URL}/api/contracts/signature-status/${encodeURIComponent(procedureId)}`,
      headers: { 
        'Accept': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}` 
      }
    });

    return response.data;
  } catch (error) {
    if (error.code === 'ECONNREFUSED') {
      throw new Error('Impossible de se connecter au serveur. Vérifiez que le serveur backend est en cours d\'exécution.');
    }
    throw error.response?.data?.error || error.message || 'Erreur inconnue';
  }
};

// ==================== SIGNATURE ÉLECTRONIQUE DES ATTENDANCES ====================

// Envoyer des invitations de signature
export const sendSignatureInvitations = async (attendanceIds) => {
  try {
    if (!attendanceIds || !Array.isArray(attendanceIds)) {
      throw new Error('Liste des attendances requise');
    }

    const response = await axios.post(
      `${API_BASE_URL}/api/attendances/send-signature-invitations`,
      { 
        attendanceIds
      },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
        },
        timeout: 30000
      }
    );
    
    if (!response || response.status !== 200) {
      throw new Error(`Échec de l'envoi des invitations: ${response?.statusText || 'Erreur de connexion'}`);
    }
    
    return response.data;
  } catch (error) {
    if (error.code === 'ECONNREFUSED') {
      throw new Error('Impossible de se connecter au serveur. Vérifiez que le serveur backend est en cours d\'exécution.');
    }
    throw error.response?.data?.error || error.message || 'Erreur inconnue';
  }
};
